const migratedFlowConstant = {
  URL_APPEND: 'pp-app',
};

export default migratedFlowConstant;
